/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * ERP API
 * 날짜·요일·시간 요청 및 응답은 UTC 기준입니다. 시간대 없는 date/time/date-time 값도 UTC로 해석하며 서버에서 KST로 변환하지 않습니다. 프런트에서 시간대를 변환할 때 날짜와 요일도 함께 변환해야 합니다. 날짜 검색의 from/to는 UTC 시작 포함·종료 미포함입니다. time_zone을 지원하는 조회의 날짜 그룹은 해당 시간대를 따릅니다. 생일 등 날짜 자체를 의미하는 값은 입력한 날짜를 그대로 사용합니다.
 * OpenAPI spec version: v1
 */
import type {
  BaseResponseLessonAttendanceDetailResponse,
  BaseResponseLessonAttendanceOverviewResponse,
  BaseResponseLessonCreateResponse,
  BaseResponseLessonDailyAttendanceResponse,
  BaseResponseLessonDailyStudentAttendanceResponse,
  BaseResponseLessonDetailResponse,
  BaseResponseLessonEnrollmentBillingSummaryResponse,
  BaseResponseLessonEnrollmentCreateResponse,
  BaseResponseLessonEnrollmentSessionsUpdateResponse,
  BaseResponseLessonSearchOptionsResponse,
  BaseResponseLessonSessionScheduleResponse,
  BaseResponseLessonSessionStudentJournalListResponse,
  BaseResponseLessonStudentJournalSummaryResponse,
  BaseResponseListLessonExamLessonResponse,
  BaseResponseMyLessonDetailResponse,
  BaseResponsePageResponseLessonBillingOptionResponse,
  BaseResponsePageResponseLessonCanceledEnrollmentStudentListItemResponse,
  BaseResponsePageResponseLessonEnrollmentStudentListItemResponse,
  BaseResponsePageResponseLessonListItemResponse,
  BaseResponseTodayLessonResponse,
  BaseResponseVoid,
  LessonAttendanceUpdateRequest,
  LessonBasicInfoUpdateRequest,
  LessonBillingBookUpdateRequest,
  LessonCreateRequest,
  LessonEnrollmentBillingUpdateRequest,
  LessonEnrollmentCreateRequest,
  LessonEnrollmentSessionsUpdateRequest,
  LessonGetAttendanceDetailParams,
  LessonGetAttendanceOverviewParams,
  LessonGetBillingSettingsParams,
  LessonGetCanceledEnrollmentStudentsParams,
  LessonGetDailyAttendanceParams,
  LessonGetDailyStudentAttendanceParams,
  LessonGetEnrollmentBillingSummaryParams,
  LessonGetEnrollmentStudentsParams,
  LessonGetInactiveAttendanceOverviewParams,
  LessonGetListParams,
  LessonGetMyLessonDetailParams,
  LessonGetSearchOptionsParams,
  LessonGetTodayLessonsParams,
  LessonManagersUpdateRequest,
  LessonOneSessionMinutesUpdateRequest,
  LessonOnlineLinkUpdateRequest,
  LessonSessionScheduleUpdateRequest,
  LessonSessionStudentJournalUpdateRequest,
  LessonSessionStudentMemoUpdateRequest,
  LessonStudentCancelRequest,
} from '.././models';

import { customInstance } from '../../../../shared/apiClient/orvalMutator';

export const getLesson = () => {
  /**
   * @summary 강사용 수업 온라인 링크 수정
   */
  const lessonUpdateOnlineLink = (lessonId: number, lessonOnlineLinkUpdateRequest: LessonOnlineLinkUpdateRequest) => {
    return customInstance<BaseResponseVoid>({
      url: `/api/lessons/${lessonId}/online-link`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: lessonOnlineLinkUpdateRequest,
    });
  };
  /**
   * 기록용 1회 수강시간만 수정합니다. 회차/시간표 등 다른 데이터는 변경하지 않습니다.
   * @summary 수업 1회 수강시간 수정
   */
  const lessonUpdateOneSessionMinutes = (lessonId: number, lessonOneSessionMinutesUpdateRequest: LessonOneSessionMinutesUpdateRequest) => {
    return customInstance<BaseResponseVoid>({
      url: `/api/lessons/${lessonId}/one-session-minutes`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: lessonOneSessionMinutesUpdateRequest,
    });
  };
  /**
   * 관리자·직원이 같은 학원의 재직 직원들을 선택합니다. 기존 직원 목록의 academy_user_id를 사용하며, 빈 배열은 전체 해제합니다. 담당강사와 별개입니다. 자동 출결 알림의 LESSON_MANAGER 수신자로 사용됩니다.
   * @summary 수업 운영 담당자 변경
   */
  const updateManagers = (lessonId: number, lessonManagersUpdateRequest: LessonManagersUpdateRequest) => {
    return customInstance<BaseResponseVoid>({
      url: `/api/lessons/${lessonId}/managers`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: lessonManagersUpdateRequest,
    });
  };
  /**
   * 신규 수강 등록에 사용할 수업 수강료/교재/기타 청구 가이드만 수정합니다. 이미 등록된 학생의 수납 내역은 변경하지 않습니다. PER_SESSION은 오늘 이후 SCHEDULED 상태인 모든 LESSON 회차의 ID와 tuition_price를 session_tuitions에 지정합니다. AMOUNT/RATE 할인은 대상 회차의 수강료 합계에 한 번 적용하며 RATE는 0~100입니다.
   * @summary 수업 수납/교재 가이드 수정
   */
  const lessonUpdateBillingBooks = (lessonId: number, lessonBillingBookUpdateRequest: LessonBillingBookUpdateRequest) => {
    return customInstance<BaseResponseVoid>({
      url: `/api/lessons/${lessonId}/billing-books`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: lessonBillingBookUpdateRequest,
    });
  };
  /**
   * @summary 수업 기본 정보 수정
   */
  const lessonUpdateBasicInfo = (lessonId: number, lessonBasicInfoUpdateRequest: LessonBasicInfoUpdateRequest) => {
    return customInstance<BaseResponseVoid>({
      url: `/api/lessons/${lessonId}/basic-info`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: lessonBasicInfoUpdateRequest,
    });
  };
  /**
   * lesson_session_student의 memo를 회차별 학생 비고로 수정합니다.
   * @summary 회차별 학생 비고 수정
   */
  const lessonUpdateSessionStudentMemo = (lessonSessionStudentId: number, lessonSessionStudentMemoUpdateRequest: LessonSessionStudentMemoUpdateRequest) => {
    return customInstance<BaseResponseVoid>({
      url: `/api/lessons/session-students/${lessonSessionStudentId}/memo`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: lessonSessionStudentMemoUpdateRequest,
    });
  };
  /**
   * lesson_session_student의 journal을 회차별 학생 수업일지로 수정합니다.
   * @summary 회차별 학생 수업일지 수정
   */
  const lessonUpdateSessionStudentJournal = (
    lessonSessionStudentId: number,
    lessonSessionStudentJournalUpdateRequest: LessonSessionStudentJournalUpdateRequest
  ) => {
    return customInstance<BaseResponseVoid>({
      url: `/api/lessons/session-students/${lessonSessionStudentId}/journal`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: lessonSessionStudentJournalUpdateRequest,
    });
  };
  /**
   * 요청 기간에 포함되는 예정 회차는 등록하고, 기간에서 제외된 회차는 해제합니다. 출결이 입력됐거나 완료된 회차는 해제할 수 없습니다. 기존 회차의 금액과 할인은 유지하며 새 회차만 현재 수업 청구 금액을 적용합니다. 제외했던 회차를 다시 추가하면 저장된 금액을 복원합니다. 교재/시험비는 유지하고 학생 개별 할인은 변경된 청구액에 다시 적용합니다.
   * @summary 수강 등록 회차 동기화
   */
  const lessonUpdateEnrollmentSessions = (lessonStudentId: number, lessonEnrollmentSessionsUpdateRequest: LessonEnrollmentSessionsUpdateRequest) => {
    return customInstance<BaseResponseLessonEnrollmentSessionsUpdateResponse>({
      url: `/api/lessons/enrollments/${lessonStudentId}/sessions`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: lessonEnrollmentSessionsUpdateRequest,
    });
  };
  /**
   * 단가가 기존 값과 같으면 회차별 금액을 유지하고, 단가를 변경하면 모든 등록 회차에 해당 단가를 적용합니다. 수업 할인액은 회차 금액 비율로 배분하고 학생 개별 할인은 교재/시험비를 포함한 남은 청구액에 적용합니다.
   * @summary 학생 수납 청구 정보 수정
   */
  const lessonUpdateEnrollmentBilling = (lessonStudentId: number, lessonEnrollmentBillingUpdateRequest: LessonEnrollmentBillingUpdateRequest) => {
    return customInstance<BaseResponseVoid>({
      url: `/api/lessons/enrollments/${lessonStudentId}/billing`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: lessonEnrollmentBillingUpdateRequest,
    });
  };
  /**
   * 요청한 lesson_student 중 REGISTERED 상태의 lesson_session_student가 있는 항목만 CANCELED로 변경하고, 아직 시작하지 않은 등록 회차의 lesson_session_student를 CANCELED로 변경합니다. 삭제하지 않으므로 취소 이력 조회가 가능합니다.
   * @summary 수강 등록 취소
   */
  const lessonCancelLessonStudents = (lessonStudentCancelRequest: LessonStudentCancelRequest) => {
    return customInstance<BaseResponseVoid>({
      url: `/api/lessons/enrollments/cancel`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: lessonStudentCancelRequest,
    });
  };
  /**
   * 회차별 학생 출결 상태와 수업 방식(ONLINE, OFFLINE, VOD)을 수정합니다.
   * @summary 출결 상태 수정
   */
  const lessonUpdateAttendance = (lessonAttendanceUpdateRequest: LessonAttendanceUpdateRequest) => {
    return customInstance<BaseResponseVoid>({
      url: `/api/lessons/attendance`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: lessonAttendanceUpdateRequest,
    });
  };
  /**
   * 관리자/스태프는 학원 수업을 조회하고, 강사는 본인이 담당하는 수업만 조회합니다. keyword는 과목명·강사명·수업명 중 하나에 포함되면 조회하는 대소문자 구분 없는 통합 검색입니다. 앞뒤 공백을 제거하며 빈 값은 검색 조건에서 제외합니다. 기존 개별 필터와 함께 전달하면 모두 만족해야 합니다. 현원은 PENDING, ACTIVE, COMPLETED 상태의 수강생 수입니다. is_operating=true면 운영중 수업만, false면 운영/미운영 전체를 조회합니다. page/size를 모두 생략하면 전체 조회하며 둘 다 전달하면 1부터 시작하는 페이지 조회입니다. 하나만 전달하거나 0 이하 값이면 400 VALIDATION_ERROR입니다. 전체 조회도 기존 PageResponse 구조를 유지하며 page=1, size=조회 건수입니다.
   * @summary 수업 목록 조회
   */
  const lessonGetList = (params: LessonGetListParams) => {
    return customInstance<BaseResponsePageResponseLessonListItemResponse>({ url: `/api/lessons`, method: 'GET', params });
  };
  /**
   * starts_at/ends_at은 UTC ISO-8601 일시입니다. 첫 회차 시작/마지막 회차 종료 일시와 일치해야 합니다. 회차 session_date/start_time/end_time은 기존 UTC 값이며 종료 시간이 시작 이하이면 다음 날 종료로 해석합니다. 전체 수강료는 서버에서 합산하며 lesson_total_price는 무시합니다. PER_SESSION은 각 LESSON 회차의 tuition_price가 필수입니다. AMOUNT/RATE 할인은 수강료 전체 합계에 한 번 적용하며 RATE는 0~100입니다. manager_academy_user_ids로 같은 학원의 재직 직원을 운영 담당자로 지정할 수 있으며, 생략 또는 빈 배열이면 미지정입니다. 담당자 검증 실패 시 수업 생성도 취소됩니다.
   * @summary 수업 생성
   */
  const lessonCreate = (lessonCreateRequest: LessonCreateRequest) => {
    return customInstance<BaseResponseLessonCreateResponse>({
      url: `/api/lessons`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: lessonCreateRequest,
    });
  };
  /**
   * LESSON 회차의 금액과 학생 수업 할인액을 회차별로 저장하고 총 청구액을 서버에서 계산합니다. PER_SESSION 수업은 선택 회차의 수업 청구 금액을 사용하며, UNIFORM 수업은 요청한 학생 단가를 사용합니다. lesson_discount_amount는 선택 회차 금액 비율로 배분합니다. total_charge_amount 입력은 무시합니다. 등록 알림이 활성화된 경우, 상담에서 문의한 해당 수업의 최초 등록 완료 즉시 설정된 직원에게 사이트 내 알림을 생성합니다. 학생·수업별 1회이며 취소·환불 후 재등록은 제외합니다.
   * @summary 수강 신청
   */
  const lessonCreateEnrollment = (lessonEnrollmentCreateRequest: LessonEnrollmentCreateRequest) => {
    return customInstance<BaseResponseLessonEnrollmentCreateResponse>({
      url: `/api/lessons/enrollments`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: lessonEnrollmentCreateRequest,
    });
  };
  /**
   * 전체 유효 교시를 UTC 날짜/시작시간/ID 순으로 반환합니다. 학생은 REGISTERED 교시 등록만 포함하고 학생 수는 학생 ID 중복을 제거합니다. 학생 없는 교시도 반환합니다. tuition_amount는 TUITION 기준 할인 후 금액, billing_amount는 학생별 회차 청구 스냅샷 금액입니다. 전체 수강 개인 할인·교재비·시험비는 포함하지 않습니다. 청구 데이터 없으면 null, 무료이면 0입니다. 회차 번호는 LESSON만 일정순으로 계산하므로 변경 후 달라질 수 있습니다. 프런트에서 현지 날짜별로 그룹화하고 학생을 중복 제거합니다. changeable은 조회 시점 기준이며 저장 시 재검증합니다.
   * @summary 수업 일정 변경용 교시·학생·청구 금액 조회
   */
  const getSessionSchedule = (lessonId: number) => {
    return customInstance<BaseResponseLessonSessionScheduleResponse>({ url: `/api/lessons/${lessonId}/session-schedule`, method: 'GET' });
  };
  /**
   * 회차 ID로 지정한 교시의 날짜와 시간을 일괄 변경합니다. 날짜와 시간은 UTC이며 모두 필수입니다. 날짜만 변경해도 기존 시간을 전달합니다. 종료 시간이 시작보다 이르면 다음 UTC 날짜 종료로 처리합니다. 시작 전 SCHEDULED 회차만 허용하며 출결 이력이 있으면 거절합니다. 수강 연결과 청구 정보는 유지하며 수업 전체 기간을 갱신합니다. 연결된 Zoom 회의의 외부 일정은 자동 변경하지 않습니다.
   * @summary 수업 회차 일정 변경
   */
  const updateSessionSchedule = (lessonId: number, lessonSessionScheduleUpdateRequest: LessonSessionScheduleUpdateRequest) => {
    return customInstance<BaseResponseVoid>({
      url: `/api/lessons/${lessonId}/session-schedule`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: lessonSessionScheduleUpdateRequest,
    });
  };
  /**
   * 관리자/스태프는 학원 수업을 조회하고, 강사는 본인이 담당하는 수업만 조회할 수 있습니다. zoom_meetings에 수업 공용 및 해당 수업의 유효 회차에 연결된 Zoom 회의를 반환하며 미연동 시 빈 목록입니다.
   * @summary 수업 상세 조회
   */
  const lessonGetDetail = (lessonId: number) => {
    return customInstance<BaseResponseLessonDetailResponse>({ url: `/api/lessons/${lessonId}`, method: 'GET' });
  };
  /**
   * @summary 수업 삭제
   */
  const lessonDelete = (lessonId: number) => {
    return customInstance<BaseResponseVoid>({ url: `/api/lessons/${lessonId}`, method: 'DELETE' });
  };
  /**
   * UTC from/to 범위를 함께 지정하면 date보다 우선합니다. 시작 포함·종료 미포함, 최대 24시간이며 잘못된 범위는 BAD_REQUEST. date를 함께 보내면 응답의 날짜 표시값으로 사용합니다.
   * @summary 오늘의 수업 조회
   */
  const lessonGetTodayLessons = (params: LessonGetTodayLessonsParams) => {
    return customInstance<BaseResponseTodayLessonResponse>({ url: `/api/lessons/today`, method: 'GET', params });
  };
  /**
   * 학생은 본인, 학부모는 연결된 자녀가 수강 중인 수업 목록을 조회합니다.
   * @summary 학생/학부모 수강 수업 조회
   */
  const lessonGetMyExamLessons = () => {
    return customInstance<BaseResponseListLessonExamLessonResponse>({ url: `/api/lessons/students/my-lessons`, method: 'GET' });
  };
  /**
   * 학생은 본인 기준으로 lesson_id의 수업 정보를 조회합니다. 학부모는 lesson_student_id를 함께 보내 해당 자녀 수강 기준으로 조회합니다. 등록 회차 시작/종료일은 실제 REGISTERED lesson_session_student 기준이며 registered_session_count는 그중 session_type=LESSON인 회차만 집계합니다. online_link는 반환하지 않습니다. 선택된 수강의 가장 가까운 남은 등록 회차(진행 중 포함)를 홈과 같은 기준으로 선택하여 lesson_session_student_id/session_date/start_time/end_time 및 online_enabled/online_status를 반환합니다. 대상 회차가 없으면 ID/날짜/시간은 null, 버튼은 비활성입니다. 학부모는 PARENT_VIEW로 비활성입니다. 학생 입장은 POST /api/students/schedule/{lesson_session_student_id}/online-join을 사용합니다.
   * @summary 학생/학부모 수업 정보 조회
   */
  const lessonGetMyLessonDetail = (lessonId: number, params?: LessonGetMyLessonDetailParams) => {
    return customInstance<BaseResponseMyLessonDetailResponse>({ url: `/api/lessons/students/my-lessons/${lessonId}`, method: 'GET', params });
  };
  /**
   * @summary 회차별 학생 수업일지 목록 조회
   */
  const lessonGetSessionStudentJournals = (lessonSessionId: number) => {
    return customInstance<BaseResponseLessonSessionStudentJournalListResponse>({ url: `/api/lessons/sessions/${lessonSessionId}/journals`, method: 'GET' });
  };
  /**
   * @summary 수업 검색 옵션 조회
   */
  const lessonGetSearchOptions = (params: LessonGetSearchOptionsParams) => {
    return customInstance<BaseResponseLessonSearchOptionsResponse>({ url: `/api/lessons/search-options`, method: 'GET', params });
  };
  /**
   * lessonStudentId 기준으로 수업 정보, 수강 기간 요약, 회차별 수업일지 목록을 조회합니다.
   * @summary 수강 수업일지 조회
   */
  const lessonGetStudentJournalSummary = (lessonStudentId: number) => {
    return customInstance<BaseResponseLessonStudentJournalSummaryResponse>({ url: `/api/lessons/enrollments/${lessonStudentId}/journals`, method: 'GET' });
  };
  /**
   * 수강 학생의 로그인 ID, 학생 이메일, 학부모 이메일과 잔여 횟수를 포함해 조회합니다. total_session_count는 LESSON 타입 등록 회차 수이며, remaining_session_count는 그중 attendance_status가 없는 회차 수입니다.
   * @summary 수강 등록 학생 목록 조회
   */
  const lessonGetEnrollmentStudents = (params: LessonGetEnrollmentStudentsParams) => {
    return customInstance<BaseResponsePageResponseLessonEnrollmentStudentListItemResponse>({ url: `/api/lessons/enrollments/students`, method: 'GET', params });
  };
  /**
   * 취소/환불 수강 학생의 로그인 ID, 학생 이메일과 학부모 이메일을 포함해 조회합니다.
   * @summary 취소/환불 수강 학생 목록 조회
   */
  const lessonGetCanceledEnrollmentStudents = (params: LessonGetCanceledEnrollmentStudentsParams) => {
    return customInstance<BaseResponsePageResponseLessonCanceledEnrollmentStudentListItemResponse>({
      url: `/api/lessons/enrollments/canceled-students`,
      method: 'GET',
      params,
    });
  };
  /**
   * 기존 lesson_billing과 student_billings 구조로 수업 기준 청구서와 학생별 청구 정보를 반환합니다. 수업 tuition_original_amount는 할인 전 전체 수강료, tuition_total_amount는 할인 후 금액입니다. 학생 tuition_total_amount는 할인 전 회차 금액 합계입니다. tuition_hourly_price는 수업과 학생 각각에 저장된 값이며 미설정은 null입니다. book_original_amount/test_original_amount는 할인 전 비용, book_test_discount_amount는 두 비용의 할인액 합계입니다.
   * @summary 수강 등록 수납 청구 정보 조회
   */
  const lessonGetEnrollmentBillingSummary = (params: LessonGetEnrollmentBillingSummaryParams) => {
    return customInstance<BaseResponseLessonEnrollmentBillingSummaryResponse>({ url: `/api/lessons/enrollments/billing-summary`, method: 'GET', params });
  };
  /**
   * 수업 분류(시즌/형태), 수업명, 강사명 통합 검색. 종료 수업을 포함하고 청구 규칙이 없는 수업은 제외합니다. 최신 ID 순이며 강사는 본인 수업만 조회합니다. session_tuition_prices는 원본 회차 날짜/시작시간 순의 할인 전 금액입니다. 새 수업 회차에 순서대로 대응하고 회차 수가 다르면 확인해야 합니다. 원본 회차 ID/납입일은 복사하지 않습니다. 합계는 저장된 청구 항목 기준이며 할인은 전체 수강료에 한 번 적용합니다.
   * @summary 기존 수업 청구 설정 불러오기 목록
   */
  const lessonGetBillingSettings = (params: LessonGetBillingSettingsParams) => {
    return customInstance<BaseResponsePageResponseLessonBillingOptionResponse>({ url: `/api/lessons/billing-settings`, method: 'GET', params });
  };
  /**
   * 수업의 전체 회차와 학생별 등록 회차 출결 현황을 조회합니다. 각 회차별 수업 방식, 출결 체크 시간과 최종 출결 처리 출처를 포함합니다. progressed_session_count는 학생이 등록한 회차 중 session_status가 DONE인 회차 수입니다.
   * @summary 수업 전체 출결 현황 조회
   */
  const lessonGetAttendanceOverview = (params: LessonGetAttendanceOverviewParams) => {
    return customInstance<BaseResponseLessonAttendanceOverviewResponse>({ url: `/api/lessons/attendance-overview`, method: 'GET', params });
  };
  /**
   * 수업의 전체 회차와 퇴원(DROPPED), 취소(CANCELED), 환불(REFUNDED) 학생의 등록 회차 출결 현황을 조회하며, 각 회차별 수업 방식, 출결 체크 시간과 최종 출결 처리 출처를 포함합니다.
   * @summary 수업 전체 출결 현황 조회 - 퇴원/취소/환불 학생
   */
  const lessonGetInactiveAttendanceOverview = (params: LessonGetInactiveAttendanceOverviewParams) => {
    return customInstance<BaseResponseLessonAttendanceOverviewResponse>({ url: `/api/lessons/attendance-overview/inactive-students`, method: 'GET', params });
  };
  /**
   * date 또는 UTC from/to 범위로 조회합니다. from/to는 함께 지정하고 시작 포함·종료 미포함이며 date보다 우선합니다(최대 24시간). date 생략 시 응답 날짜는 from의 UTC 날짜입니다. 범위 누락/역전/초과는 BAD_REQUEST. 수업, 학생, 날짜 기준으로 회차별 최종 출결 정보와 입장·퇴장·상태 변경 이력을 조회합니다.
   * @summary 학생 출결 내역 상세 조회
   */
  const lessonGetAttendanceDetail = (params: LessonGetAttendanceDetailParams) => {
    return customInstance<BaseResponseLessonAttendanceDetailResponse>({ url: `/api/lessons/attendance-detail`, method: 'GET', params });
  };
  /**
   * date 또는 UTC from/to 범위로 조회합니다. from/to는 함께 지정하고 시작 포함·종료 미포함이며 date보다 우선합니다(최대 24시간). date 생략 시 응답 날짜는 from의 UTC 날짜입니다. 범위 누락/역전/초과는 BAD_REQUEST. 수업과 날짜 기준으로 해당 일자의 회차별 출석부를 조회합니다.
   * @summary 일일 출석부 조회
   */
  const lessonGetDailyAttendance = (params: LessonGetDailyAttendanceParams) => {
    return customInstance<BaseResponseLessonDailyAttendanceResponse>({ url: `/api/lessons/attendance-daily`, method: 'GET', params });
  };
  /**
   * date 또는 UTC from/to 범위로 조회합니다. from/to는 함께 지정하고 시작 포함·종료 미포함이며 date보다 우선합니다(최대 24시간). date 생략 시 응답 날짜는 from의 UTC 날짜입니다. 범위 누락/역전/초과는 BAD_REQUEST. 수업과 날짜 기준으로 학생별 수강 정보와 회차별 출결 현황을 조회합니다. remaining_session_count는 등록 회차 중 attendance_status가 없는 회차 수입니다.
   * @summary 학생별 일일 출석부 조회
   */
  const lessonGetDailyStudentAttendance = (params: LessonGetDailyStudentAttendanceParams) => {
    return customInstance<BaseResponseLessonDailyStudentAttendanceResponse>({ url: `/api/lessons/attendance-daily/students`, method: 'GET', params });
  };
  return {
    lessonUpdateOnlineLink,
    lessonUpdateOneSessionMinutes,
    updateManagers,
    lessonUpdateBillingBooks,
    lessonUpdateBasicInfo,
    lessonUpdateSessionStudentMemo,
    lessonUpdateSessionStudentJournal,
    lessonUpdateEnrollmentSessions,
    lessonUpdateEnrollmentBilling,
    lessonCancelLessonStudents,
    lessonUpdateAttendance,
    lessonGetList,
    lessonCreate,
    lessonCreateEnrollment,
    getSessionSchedule,
    updateSessionSchedule,
    lessonGetDetail,
    lessonDelete,
    lessonGetTodayLessons,
    lessonGetMyExamLessons,
    lessonGetMyLessonDetail,
    lessonGetSessionStudentJournals,
    lessonGetSearchOptions,
    lessonGetStudentJournalSummary,
    lessonGetEnrollmentStudents,
    lessonGetCanceledEnrollmentStudents,
    lessonGetEnrollmentBillingSummary,
    lessonGetBillingSettings,
    lessonGetAttendanceOverview,
    lessonGetInactiveAttendanceOverview,
    lessonGetAttendanceDetail,
    lessonGetDailyAttendance,
    lessonGetDailyStudentAttendance,
  };
};
export type LessonUpdateOnlineLinkResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getLesson>['lessonUpdateOnlineLink']>>>;
export type LessonUpdateOneSessionMinutesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getLesson>['lessonUpdateOneSessionMinutes']>>>;
export type UpdateManagersResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getLesson>['updateManagers']>>>;
export type LessonUpdateBillingBooksResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getLesson>['lessonUpdateBillingBooks']>>>;
export type LessonUpdateBasicInfoResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getLesson>['lessonUpdateBasicInfo']>>>;
export type LessonUpdateSessionStudentMemoResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getLesson>['lessonUpdateSessionStudentMemo']>>>;
export type LessonUpdateSessionStudentJournalResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getLesson>['lessonUpdateSessionStudentJournal']>>>;
export type LessonUpdateEnrollmentSessionsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getLesson>['lessonUpdateEnrollmentSessions']>>>;
export type LessonUpdateEnrollmentBillingResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getLesson>['lessonUpdateEnrollmentBilling']>>>;
export type LessonCancelLessonStudentsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getLesson>['lessonCancelLessonStudents']>>>;
export type LessonUpdateAttendanceResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getLesson>['lessonUpdateAttendance']>>>;
export type LessonGetListResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getLesson>['lessonGetList']>>>;
export type LessonCreateResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getLesson>['lessonCreate']>>>;
export type LessonCreateEnrollmentResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getLesson>['lessonCreateEnrollment']>>>;
export type GetSessionScheduleResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getLesson>['getSessionSchedule']>>>;
export type UpdateSessionScheduleResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getLesson>['updateSessionSchedule']>>>;
export type LessonGetDetailResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getLesson>['lessonGetDetail']>>>;
export type LessonDeleteResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getLesson>['lessonDelete']>>>;
export type LessonGetTodayLessonsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getLesson>['lessonGetTodayLessons']>>>;
export type LessonGetMyExamLessonsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getLesson>['lessonGetMyExamLessons']>>>;
export type LessonGetMyLessonDetailResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getLesson>['lessonGetMyLessonDetail']>>>;
export type LessonGetSessionStudentJournalsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getLesson>['lessonGetSessionStudentJournals']>>>;
export type LessonGetSearchOptionsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getLesson>['lessonGetSearchOptions']>>>;
export type LessonGetStudentJournalSummaryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getLesson>['lessonGetStudentJournalSummary']>>>;
export type LessonGetEnrollmentStudentsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getLesson>['lessonGetEnrollmentStudents']>>>;
export type LessonGetCanceledEnrollmentStudentsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getLesson>['lessonGetCanceledEnrollmentStudents']>>>;
export type LessonGetEnrollmentBillingSummaryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getLesson>['lessonGetEnrollmentBillingSummary']>>>;
export type LessonGetBillingSettingsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getLesson>['lessonGetBillingSettings']>>>;
export type LessonGetAttendanceOverviewResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getLesson>['lessonGetAttendanceOverview']>>>;
export type LessonGetInactiveAttendanceOverviewResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getLesson>['lessonGetInactiveAttendanceOverview']>>>;
export type LessonGetAttendanceDetailResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getLesson>['lessonGetAttendanceDetail']>>>;
export type LessonGetDailyAttendanceResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getLesson>['lessonGetDailyAttendance']>>>;
export type LessonGetDailyStudentAttendanceResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getLesson>['lessonGetDailyStudentAttendance']>>>;
